<template>
    <div class="clearfix title-box">
        
        <div 
            v-if="infor.title!=''&& infor.title!=null" 
            class="title"
        >
            {{infor.title}}
        </div>

        <div 
            class="tag" 
            v-if="infor.tag!=null && infor.tag!=''"
        >
            <p 
                class="tag_text" 
                v-html="infor.tag"
            >
            </p>

            <router-link 
                class="tag_btn" 
                :to="infor.btnLink"
            >
                {{infor.btnText}}
            </router-link>

        </div>

    </div>
</template>
<script>
// import jquery from 'jquery'

export default {
    name: 'BaseTitle',
    props: {
        infor: Object
    },
    data: function() {
        return {

        }
    },
    updated: function() {

    },
    mounted() {
        // let _this = this;
        // setTimeout(function(){
        //     console.log(_this.$parent.infor.title);
        //     console.log(_this.tag); 
        // }, 100)
    }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*@media*/
@media screen and (min-width: 801px) {
    .title-box {
        max-width: 1200px;
        margin: 0 auto;
         padding: 30px 0 50px;
    }

    .title {
        float: left;
        max-width: 770px;
        line-height: 126px;
        font-size: 96px;
    }

    .tag {
        float: right;
        padding-left: 10px;
        border-left: 2px #333 solid;
    }

    .tag_text {
        width: 240px;
        line-height: 42px;
        font-size: 30px;
        height: 84px;
    }

    .tag_btn {
        padding-top: 15px;
        padding-bottom: 2px;
        border-bottom: 1px #333 solid;
        display: inline-block;
        font-size: 20px;
    }

    .tag_btn:hover {
        border-bottom: 1px #FF764E solid;
    }
}

@media screen and (min-width: 801px) and (max-width: 1200px) {
    .title {
        padding-left: 20px;
    }
}

@media screen and (max-width: 800px) {

    .title-box {
        width: 9.04rem;
        margin: 0 auto;
    }

    .title {
        float: left;
        font-size: .64rem;
        padding-top: .32rem;
        font-weight: 600;
    }

    .tag {
        float: right;
        padding-left: 10px;
        border-left: 2px #333 solid;
    }

    .tag_text {
        width: 2.45rem;
        font-size: .32rem;
        height: .9rem;
        line-height: .45rem;
    }

    .tag_btn {
        padding-top: .2rem;
        padding-bottom: 2px;
        border-bottom: 1px #333 solid;
        display: inline-block;
        font-size: .32rem;
    }

    .tag_btn:active {
        border-bottom: 1px #FF764E solid;
    }



}
</style>